import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Oval } from "react-loader-spinner";
import LabelForm from "pages/signup/form/labelForm";
import BGShutterstock from "images/auth/bg-shutterstock.png";
import { ReactComponent as TVendorIcon } from "images/auth/t-vendors.svg";
import { ReactComponent as ApprovedImage } from "images/externalPage/high-five.svg";
import { ReactComponent as DeclineImage } from "images/externalPage/decline-image.svg";
import useConfirmPOAssignee from "./useConfirmPOAssignee";

const ConfirmPOAssignee = () => {
  const [t] = useTranslation();

  const { handleSubmit } = useForm();

  const { onSubmit, navigate, isLoading, approvedParam, successMsg } =
    useConfirmPOAssignee();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div
        className="w-full h-[100px] bg-no-repeat  bg-cover bg-center flex items-center px-[20%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] fixed z-[999999999]"
        style={{
          backgroundImage: `url(${BGShutterstock})`,
          zIndex: 100,
        }}
      >
        <div className="max-w-[843px] w-full flex items-center justify-between">
          <TVendorIcon
            onClick={() => navigate("/login")}
            className="cursor-pointer"
          />
        </div>
      </div>

      {!successMsg ? (
        <div className="mt-[220px] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
          <LabelForm
            label={
              approvedParam === "true"
                ? t("approvalRequest")
                : t("rejectRequest")
            }
            labelClassName="text-primary font-bold text-[28px] md-max:text-[20px] not-italic mb-[30px] text-center"
          />

          <LabelForm
            label={
              approvedParam === "true"
                ? t("POAssigneeAcceptMsg")
                : t("POAssigneeDeclineMsg")
            }
            labelClassName="text-primary font-bold text-[20px] md-max:text-[16px] not-italic"
          />
          <div className="flex items-end justify-end gap-[10px] mt-[40px]">
            <button
              type="submit"
              disabled={isLoading}
              className="cursor-pointer flex py-[14px] px-[16px] gap-[8px] justify-center items-center rounded-[6px] border-[1px] border-solid border-primary bg-primary h-[46px] w-[150px]"
            >
              <Oval
                height={30}
                width={30}
                color="#FFF"
                visible={isLoading}
                ariaLabel="oval-loading"
                secondaryColor="#FFF"
                strokeWidth={5}
                strokeWidthSecondary={3}
              />
              <div className="text-white font-bold text-[16px] not-italic">
                {t("Yes")}
              </div>
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-[220px] px-[10%] xl-max:px-[10%] lg-max:px-[2rem] md-max:px-[1rem] flex flex-col mb-[97px] relative min-h-[calc(100vh-750px)] items-center justify-center">
          {approvedParam === "true" ? <ApprovedImage /> : <DeclineImage />}
          <LabelForm
            label={t(successMsg)}
            labelClassName="text-primary font-bold text-[22px] md-max:text-[18px] not-italic ml-[15px]"
          />
        </div>
      )}
    </form>
  );
};

export default ConfirmPOAssignee;
